import { Controller } from "@hotwired/stimulus";
import { phoneNumberFormatter } from "../application/phoneNumberFormatter.js";

export default class InvestorCategoryStepController extends Controller {
  static targets = [
    "professionalLegalInvestorByNature",
    "professionalLegalInvestor",
    "notProfessionalLegalInvestor",
    "professionalLegalInvestorByNatureBlock",
    "professionalLegalInvestorBlock",
    "nonFinancialEntityBlock",
    "firstSignerPhoneNumber",
    "firstSignerPhoneNumberError",
    "secondSignerPhoneNumber",
    "secondSignerPhoneNumberError",
  ];

  connect() {
    this.toggleBlocks();

    phoneNumberFormatter(this.firstSignerPhoneNumberTarget, this.firstSignerPhoneNumberErrorTarget);
    phoneNumberFormatter(this.secondSignerPhoneNumberTarget, this.secondSignerPhoneNumberErrorTarget);
  }

  toggleBlocks() {
    if (this.professionalLegalInvestorTarget.checked) {
      this.nonFinancialEntityBlockTarget.classList.remove("d-none");
      this.professionalLegalInvestorBlockTarget.classList.remove("d-none");
      this.professionalLegalInvestorByNatureBlockTarget.classList.add("d-none");
    } else if (this.notProfessionalLegalInvestorTarget.checked) {
      this.nonFinancialEntityBlockTarget.classList.remove("d-none");
      this.professionalLegalInvestorBlockTarget.classList.add("d-none");
      this.professionalLegalInvestorByNatureBlockTarget.classList.add("d-none");
    } else if (this.professionalLegalInvestorByNatureTarget.checked) {
      this.professionalLegalInvestorBlockTarget.classList.add("d-none");
      this.professionalLegalInvestorByNatureBlockTarget.classList.remove("d-none");
      this.nonFinancialEntityBlockTarget.classList.add("d-none");
    } else {
      this.nonFinancialEntityBlockTarget.classList.add("d-none");
    }
  }
}
